import { useCallback, useEffect, useState } from 'react';

/**
 * A hook that tracks the browser window's width in pixels.
 * Updates automatically when the window is resized.
 *
 * @returns {number} The current window width in pixels
 */
export const useScreenWidth = (): number => {
  const [width, setWidth] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth;
    }
    return 0;
  });

  const handleResize = useCallback(() => {
    setWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return width;
};
